import { useAxios } from 'src/hooks/use-axios';

export function useDeleteComfortBid() {
  return useAxios(
    (axios, baseConfig, comfortBidId: number) =>
      axios.request<null>({
        ...baseConfig,
        method: 'DELETE',
        url: `${PRISMA_CONFIG.monolithApiUrl}/auctions/${comfortBidId}`,
      }),
    { neededOnPageLoad: false }
  );
}

export type DeleteComfortBidRequest = ReturnType<typeof useDeleteComfortBid>;
